import { render, staticRenderFns } from "./onlineDoc.vue?vue&type=template&id=bd5c3f66&scoped=true&"
import script from "./onlineDoc.vue?vue&type=script&lang=js&"
export * from "./onlineDoc.vue?vue&type=script&lang=js&"
import style0 from "./onlineDoc.vue?vue&type=style&index=0&id=bd5c3f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c3f66",
  null
  
)

export default component.exports